/**
 * 骨組み・共通部品・エラーの文言（ja / en）。i18n.ts が合成する。
 * 見出し・ボタンは「〜する」の能動形。エラーは ①何が起きたか ②入力は残っているか ③次の操作。
 */
export const ja: Record<string, string> = {
  "common.close": "閉じる",
  "nav.home": "ホーム",
  "nav.report": "報告",
  "nav.menu": "メニュー",
  "nav.label": "画面の一覧",
  "nav.tabs": "よく使う画面",
  "nav.skip": "本文へ移動",
  "navg.work": "業務",
  "navg.records": "記録・台帳",
  "navg.cycle": "年次サイクル",
  "navg.admin": "管理",
  "notif.unreadCount": "未読 {n} 件",

  "search.open": "探す",
  "search.title": "探す",
  "search.label": "画面名・申請番号・台帳・評価基準番号で探す",
  "search.placeholder": "例: 申請、2026-0012、4-1-3-4、ソフトウェア",
  "search.hint": "↑↓ で選び Enter で開きます。パソコンでは ⌘K / Ctrl+K でいつでも開けます。",
  "search.results": "候補",
  "search.none": "見つかりませんでした。言葉を短くしてみてください。",
  "search.kind.page": "画面",
  "search.kind.request": "申請",
  "search.kind.criterion": "評価基準",
  "search.kind.register": "台帳",
  "search.kind.row": "台帳の行",

  "asof.label": "表示している時点",
  "asof.band.date": "{date} 時点の記録を表示しています",
  "asof.band.time": "{time} 時点の記録を表示しています（その後の更新は出ていません）",
  "asof.backToLatest": "最新に戻る",
  "asof.pick": "時点を選んで見る",
  "asof.pickHint": "選んだ日の時点の記録で、準備度・評価基準・台帳を表示します。表示中は画面上部に帯が出ます。",
  "asof.goTo": "{date} 時点に戻して見る",

  "sys.offline": "オフラインです。通信が戻るまで送信はできません（入力は消えません）。",
  "sys.newVersion": "新しい版があります",
  "sys.newVersionBody": "画面を再読み込みすると最新の版になります。",
  "sys.reload": "再読み込み",
  "sys.later": "あとで",

  "err.unknown.title": "処理できませんでした",
  "err.unknown.body": "もう一度送ってください。続くときはセキュリティ担当部署長に連絡してください。",
  "err.load.title": "読み込めませんでした",
  "err.load.body": "再読み込みを押してください。続くときはセキュリティ担当部署長に連絡してください。",
  "err.boundary.body": "この画面の表示中に問題が起きました。再読み込みで直ることがあります。他の画面はそのまま使えます。",
  "err.network.title": "通信できませんでした",
  "err.network.body": "電波の届く場所で「もう一度送る」を押してください。二重に登録されることはありません。",
  "err.network.bodyLoad": "通信が戻ったら「再読み込み」を押してください。",
  "err.timeout.title": "時間内に応答がありませんでした",
  "err.timeout.body": "届いているかもしれないので、「もう一度送る」を押してください。二重に登録されることはありません。",
  "err.server.title": "処理できませんでした",
  "err.server.body": "サーバーで問題が起きました。もう一度送っても直らないときは、問い合わせ番号を添えて連絡してください。",
  "err.rate.title": "少し時間をおいてもう一度送ってください",
  "err.rate.body": "短い間に送信が続いたため、いったん止めています。",
  "err.tooLarge.title": "ファイルが大きすぎます",
  "err.tooLarge.body": "{mb}MB までのファイルを選んでください。",
  "err.unsupported.title": "この形式のファイルは登録できません",
  "err.unsupported.body": "別の形式で保存し直してから選んでください。",
  "err.session.title": "時間が経ったのでログインし直してください",
  "err.session.body": "ログインすると、元の画面に戻ります。入力途中の内容はこの端末に残してあります。",
  "err.totp.title": "先に認証アプリを登録してください（1分で終わります）",
  "err.forbidden.title": "この操作をする権限がありません",
  "err.forbidden.byRole": "この操作は {roles} の人ができます",
  "err.forbidden.ask": "{name}さん（{role}）に頼んでください。",
  "err.forbidden.askFallback": "セキュリティ担当部署長に頼んでください。",
  "err.notFound.title": "対象が見つかりません",
  "err.notFound.titleWhat": "{what}は見つかりません",
  "err.notFound.body": "取り下げられたか、URL が誤っている可能性があります。",
  "err.inProgress.title": "処理中です",
  "err.inProgress.body": "少し待ってから「もう一度送る」を押してください。二重に登録されることはありません。",
  "err.keyReused.title": "前の送信と内容が変わったため、受け付けませんでした",
  "err.keyReused.body": "まだ登録されていません。内容を確かめて、もう一度送ってください（新しい送信として扱います）。",
  "err.conflict.title": "他の人が先に更新しました",
  "err.conflict.body": "「最新を読み込む」で今の内容を確かめてから、もう一度操作してください。",
  "err.validation.title": "入力を確かめてください",
  "err.validation.body": "赤字の欄を直してから、もう一度送ってください。",
  "err.kept": "入力は残っています。",
  "err.contact": "続くときは {name}さん（{role}）に連絡してください。",
  "err.contactFallback": "続くときはセキュリティ担当部署長に連絡してください。",
  "err.ref": "問い合わせ番号: {id}",
  "err.refCopied": "問い合わせ番号をコピーしました",
  "err.refCopyFailed": "コピーできませんでした。問い合わせ番号は {id} です",
  "err.action.retry": "もう一度送る",
  "err.action.retryIn": "あと {n} 秒で押せます",
  "err.action.reload": "再読み込み",
  "err.action.reloadLatest": "最新を読み込む",
  "err.action.totp": "認証アプリを登録する",
  "err.action.login": "ログインし直す",
  "err.action.repick": "ファイルを選び直す",
  "err.action.copyRef": "問い合わせ番号をコピー",
  "err.fix": "{n} か所を直してください",
  "err.file.empty": "空のファイルは登録できません。中身のあるファイルを選んでください。",
  "err.file.tooLarge": "{mb}MB までの{what}を選んでください。",
  "err.file.badType": "{what}を選んでください（{mb}MB まで）。",
  "err.file.anyFile": "ファイル",
  "err.required": "入力してください",
  "err.choose": "選択肢から選んでください",
  "err.pageNotFound.title": "画面が見つかりません",
  "err.pageNotFound.body": "URL が誤っているか、画面の場所が変わりました。",
  "err.pageNotFound.home": "ホームへ戻る",

  "due.overdue": "{n}日超過",
  "due.today": "今日まで",
  "due.left": "あと{n}日",
};

export const en: Record<string, string> = {
  "common.close": "Close",
  "nav.home": "Home",
  "nav.report": "Report",
  "nav.menu": "Menu",
  "nav.label": "All screens",
  "nav.tabs": "Frequently used",
  "nav.skip": "Skip to content",
  "navg.work": "Work",
  "navg.records": "Records & registers",
  "navg.cycle": "Annual cycle",
  "navg.admin": "Administration",
  "notif.unreadCount": "{n} unread",

  "search.open": "Search",
  "search.title": "Search",
  "search.label": "Search screens, request numbers, registers and criteria",
  "search.placeholder": "e.g. request, 2026-0012, 4-1-3-4, software",
  "search.hint": "Use ↑↓ and Enter. On a computer, press ⌘K / Ctrl+K at any time.",
  "search.results": "Results",
  "search.none": "Nothing found. Try a shorter word.",
  "search.kind.page": "Screen",
  "search.kind.request": "Request",
  "search.kind.criterion": "Criterion",
  "search.kind.register": "Register",
  "search.kind.row": "Register row",

  "asof.label": "Point in time shown",
  "asof.band.date": "Showing records as of {date}",
  "asof.band.time": "Showing records as of {time} (later updates are not shown)",
  "asof.backToLatest": "Back to latest",
  "asof.pick": "View as of a date",
  "asof.pickHint": "Readiness, criteria and registers are shown as of the chosen date. A band stays at the top while you do.",
  "asof.goTo": "View as of {date}",

  "sys.offline": "You are offline. Sending is paused until the connection returns (your input is kept).",
  "sys.newVersion": "A new version is available",
  "sys.newVersionBody": "Reload the page to use the latest version.",
  "sys.reload": "Reload",
  "sys.later": "Later",

  "err.unknown.title": "This could not be processed",
  "err.unknown.body": "Please send it again. If it keeps happening, contact the security department head.",
  "err.load.title": "Could not load this",
  "err.load.body": "Press Reload. If it keeps happening, contact the security department head.",
  "err.boundary.body": "Something went wrong while showing this screen. Reloading often fixes it. Other screens still work.",
  "err.network.title": "Could not connect",
  "err.network.body": "Move to where you have signal and press “Send again”. It will not be registered twice.",
  "err.network.bodyLoad": "Press Reload once you are back online.",
  "err.timeout.title": "No response in time",
  "err.timeout.body": "It may have arrived, so press “Send again”. It will not be registered twice.",
  "err.server.title": "This could not be processed",
  "err.server.body": "The server had a problem. If sending again does not help, contact us with the reference number.",
  "err.rate.title": "Please wait a moment and send again",
  "err.rate.body": "Too many requests in a short time, so sending is paused briefly.",
  "err.tooLarge.title": "The file is too large",
  "err.tooLarge.body": "Choose a file of up to {mb} MB.",
  "err.unsupported.title": "This file type cannot be registered",
  "err.unsupported.body": "Save it in another format and choose it again.",
  "err.session.title": "Please sign in again — your session has timed out",
  "err.session.body": "After signing in you will return to the same screen. Your unfinished input is kept on this device.",
  "err.totp.title": "Register your authenticator app first (it takes a minute)",
  "err.forbidden.title": "You do not have permission for this",
  "err.forbidden.byRole": "This can be done by: {roles}",
  "err.forbidden.ask": "Please ask {name} ({role}).",
  "err.forbidden.askFallback": "Please ask the security department head.",
  "err.notFound.title": "Not found",
  "err.notFound.titleWhat": "{what} was not found",
  "err.notFound.body": "It may have been withdrawn, or the URL may be wrong.",
  "err.inProgress.title": "Still processing",
  "err.inProgress.body": "Wait a moment, then press “Send again”. It will not be registered twice.",
  "err.keyReused.title": "Not accepted because the content changed since the last attempt",
  "err.keyReused.body": "Nothing was registered. Check the content and send it again (it will be treated as a new submission).",
  "err.conflict.title": "Someone else updated this first",
  "err.conflict.body": "Press “Load latest” to check the current state, then try again.",
  "err.validation.title": "Please check your input",
  "err.validation.body": "Fix the fields marked in red and send again.",
  "err.kept": "Your input is kept.",
  "err.contact": "If it keeps happening, contact {name} ({role}).",
  "err.contactFallback": "If it keeps happening, contact the security department head.",
  "err.ref": "Reference: {id}",
  "err.refCopied": "Reference number copied",
  "err.refCopyFailed": "Could not copy. The reference number is {id}",
  "err.action.retry": "Send again",
  "err.action.retryIn": "Available in {n} s",
  "err.action.reload": "Reload",
  "err.action.reloadLatest": "Load latest",
  "err.action.totp": "Register authenticator app",
  "err.action.login": "Sign in again",
  "err.action.repick": "Choose another file",
  "err.action.copyRef": "Copy reference number",
  "err.fix": "Please fix {n} field(s)",
  "err.file.empty": "Empty files cannot be registered. Choose a file with content.",
  "err.file.tooLarge": "Choose a {what} of up to {mb} MB.",
  "err.file.badType": "Choose a {what} (up to {mb} MB).",
  "err.file.anyFile": "file",
  "err.required": "Please fill this in",
  "err.choose": "Please choose an option",
  "err.pageNotFound.title": "Screen not found",
  "err.pageNotFound.body": "The URL may be wrong, or the screen has moved.",
  "err.pageNotFound.home": "Back to Home",

  "due.overdue": "{n} days overdue",
  "due.today": "due today",
  "due.left": "{n} days left",
};
